export default {"src":"/_next/static/media/ico_stop.74a6767b.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};